import * as Utils from './utils.js';
import * as lenis from './lenis'

export default el => {
    const btn = el.querySelector('.js-contact-btn');
    const contactTypeBtns = document.querySelectorAll('.js-contact-type-btn');
    const contactTypeRadios = el.querySelectorAll('.js-contact-type-radio');
    const contactTypeSections = el.querySelectorAll('[data-contact-type]');
    const requiredFields = el.querySelectorAll('[required]');
    const errorMessage = el.querySelector('.js-contact-error-message .js-info-message');

    contactTypeRadios.forEach(item => {
        item.addEventListener('change', () => {
            contactTypeSections.forEach(section => {
                const types = section.dataset.contactType;
                section.style.display = types.includes(item.value) ? "block" : "none";
            });

            lenis.resize();

        });
    });

    contactTypeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const type = btn.dataset.contactType;
            
            contactTypeRadios.forEach(item => {
                if (item.value == type) {
                    item.checked = true;

                    var event = new Event('change');
                    item.dispatchEvent(event);
                }
            })
        });
    })

    if (!btn) return;

    const ajax = () => {
        const ajax_url = ParamsData.wp_ajax_url;
        const formData = new FormData(el);
        const xhr = new XMLHttpRequest();

        formData.append('action', el.dataset.action ? el.dataset.action : 'contact');

        el.classList.add('loading');

        xhr.open('POST', ajax_url, true);
        xhr.onreadystatechange = () => {

            if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
                const response = JSON.parse(xhr.response);

                if (response.success) {
                    if (response.url) {
                        window.location = response.url;
                        return;
                    } else {
                        el.classList.remove('error');
                        el.classList.add('validation');
                    }
                } else {
                    if (errorMessage) {
                        errorMessage.innerHTML = response.message;
                    }
                    
                    el.classList.add('error');
                    el.classList.remove('validation');

                    const grecaptchas = document.querySelectorAll('.g-recaptcha');
                    if (grecaptchas) {
                        grecaptchas.forEach(item => {
                            grecaptcha.reset(item.dataset.id);
                        });
                    }
                }

                el.classList.remove('loading');

            }

            else {
                el.classList.remove('loading');
            }

            lenis.resize();
        };

        xhr.send(formData);
    }

    btn.addEventListener('click', (e) => {
        const error = Utils.validateFields(requiredFields);

        lenis.resize();

        if (error.length == 0) {
            ajax();
        }
    })  
};